import React from 'react';
import DOMPurify from 'dompurify';
import { MenuItem } from '../models/Category';

interface ImagePopupProps {
  item: MenuItem;
  onClose: () => void;
}

const ImagePopup: React.FC<ImagePopupProps> = ({ item, onClose }) => {
  return (
    <div className="image-popup" onClick={onClose}>
      <div className="image-popup--content" onClick={(e) => e.stopPropagation()}>
        <button className="image-popup--close" onClick={onClose} aria-label="Close">X</button>
        <div className="image-popup--image" style={{ backgroundImage: `url(${encodeURI(item.img || '')})` }}></div>
        <h3>{item.itemTitle}</h3>
        <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.itemDescription || '') }}></p>
        <p className="price notranslate" translate="no">
          {Number(item.price).toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })} €
        </p>
      </div>
    </div>
  );
};

export default ImagePopup;
